import { Button, Col, Divider, Form, Image, Input, Row, Select, Switch } from "antd";
import { useCallback, useEffect, useRef, useState } from "react";
import { EditOutlined } from "@ant-design/icons";
import { useLocation, useNavigate } from "react-router-dom";
import { dispatchtoast } from "../../../Utils";
import dropDownImage from "../../../Assets/ChevronDown.png";

import { addOffer, editOffer, uploadImage, toggleStatus } from "./UserApi";
import { ImSpinner10 } from "react-icons/im";
function EditUser() {
  const location = useLocation();
  const fill = location.state?.fill;
  const from = location.state?.from;
  const [form] = Form.useForm();
  const formRef = useRef(form);
  const [contentData, setContentData] = useState({});
//   const [imageURL, setImageURL] = useState(from === "add" ? "" : fill.image);
  const [imageURL, setImageURL] = useState(fill?.image);
  const [isLoading, setIsLoading] = useState(false);
  const [uploading, setUploading] = useState(false);
  console.log(from, fill);

//   const handleFileUpload = useCallback(
//     async (e) => {
//       try {
//         setUploading(true);
//         const { files } = e.target;
//         const response = await uploadImage(files);
//         const url = response?.data?.url;
//         setImageURL(url);
//         setContentData({ ...contentData, image: url });
//         setUploading(false);
//       } catch (error) {
//         setUploading(false);
//         console.log({ error });
//       }
//     },
//     [contentData]
//   );

  const navigate = useNavigate();

//   const AddOffer = (values) => {
//     console.log(values);
//     const payload = {
//       redirectLink: values.redirectLink,
//       isActive: values.isActive,
//       rank: values.rank,
//       image: imageURL,
//       title: values.title,
//       bonus: values.bonus,
//       type: values.type,
//     };

//     setIsLoading(true);

//     addOffer(payload)
//       .then((response) => {
//         if (response.status) {
//           navigate("/get/offers_details");
//           form.resetFields();
//           setIsLoading(false);
//         } else {
//           dispatchtoast("Fields can not be empty", true);
//           setIsLoading(false);
//         }
//       })
//       .catch((error) => {
//         console.error(error);
//         setIsLoading(false);
//       });
//   };


  // const updateContentData = (values) => {
  const updateContentData = () => {
    // console.log(values);
    // const payload = {
    //   redirectLink: values.redirectLink,
    //   isActive: values.isActive,
    //   rank: values.rank,
    //   image: imageURL,
    //   title: values.title,
    //   bonus: values.bonus,
    //   type: values.type,
    // };

    setIsLoading(true);

    toggleStatus({}, `${fill?.id}`)
      .then((response) => {
        if (response?.status) {
            navigate("/get/user_details");
            form.resetFields();
            setIsLoading(false);
            //   message.open(messageConfiguration("success", response.message, 3));
            // FetchOfferData();
        } else {
            dispatchtoast("Fields can not be empty", true);
            setIsLoading(false);
        }
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });

    // editOffer(payload, `${fill?._id}`)
    //   .then((response) => {
    //     if (response.status) {
    //       navigate("/get/offers_details");
    //       form.resetFields();
    //       setIsLoading(false);
    //     } else {
    //       dispatchtoast("Fields can not be empty", true);
    //       setIsLoading(false);
    //     }
    //   })
    //   .catch((error) => {
    //     console.error(error);
    //     setIsLoading(false);
    //   });
  };

  useEffect(() => {
    if (fill) {
      form.setFieldsValue({
        userName: fill.username,
        email: fill.email,
        mobile: fill.mobile,
        country: fill.country,
        isVerified: fill.isVerified ? "True" : "False",
        isActive: fill.isActive,
        image: fill.image,
      });
    }
  }, [form, fill]);
  return (
    <div>
      <Divider orientation="left" style={{ border: "#cecece" }} className="text-base tracking-normal font-dmsans font-normal  text-gray-900">
        {/* {from === "edit" ? "Update" : "Add"} Offer */}
        User Details
      </Divider>
      <Form
        className="bg-white mt-6"
        layout="vertical"
        onFinishFailed={(err) => {
          err?.errorFields?.forEach((field) => {
            field.errors?.forEach((error) => {
              dispatchtoast(error, true);
            });
          });
        }}
        // onFinish={(values) => (from === "add" ? AddOffer(values) : updateContentData(values))}
        // onFinish={(values) => (updateContentData(values))}
        form={form}
        ref={formRef}
        // initialValues={
        //   from === "edit"
        //     ? contentData
        //     : {
        //         meta: [{ name: "Title", content: "" }],
        //         components: [{ heading: "", paragraph: [] }],
        //       }
        // }
      >
        <Row className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4">
          <Col>
            <Form.Item
              label={<p className="font-normal text-gray-900 font-dmsans text-sm leading-[22px] tracking-[-1%]">User Name</p>}
              name="userName"
              rules={[
                { required: true, message: "User Name" },
                // { min: 4, message: "User Name must be at least 4 characters" },
              ]}
            >
              <Input placeholder="User Name" disabled />
            </Form.Item>
          </Col>

          <Col>
            <Form.Item
              label={<p className="font-normal text-gray-900 font-dmsans text-sm leading-[22px] tracking-[-1%]">Email</p>}
              name="email"
              rules={[
                { required: true, message: "Please enter Email" },
                // { min: 6, message: "Email must be at least 6 characters" },
              ]}
            >
              <Input placeholder="Email" disabled />
            </Form.Item>
          </Col>
          {/* <Col> */}
            <Col>
            <Form.Item
              label={<p className="font-normal text-gray-900 font-dmsans text-sm leading-[22px] tracking-[-1%]">Mobile</p>}
              name="mobile"
              rules={[
                { required: true, message: "Please enter Mobile" },
                // { min: 6, message: "Email must be at least 6 characters" },
              ]}
            >
              <Input placeholder="Mobile" disabled />
            </Form.Item>
          </Col>

            <Col>
            <Form.Item
              label={<p className="font-normal text-gray-900 font-dmsans text-sm leading-[22px] tracking-[-1%]">Country</p>}
              name="country"
              rules={[
                { required: true, message: "Please enter Country" },
                // { min: 6, message: "Country must be at least 6 characters" },
              ]}
            >
              <Input placeholder="Country" disabled />
            </Form.Item>
          </Col>
          {/* <Col></Col> */}

          {/* </Col> */}
        </Row>

        <Row className="grid grid-cols-1 sm:grid-cols-2 gap-4">

        <Col>
            <Form.Item
              label={<p className="font-normal text-gray-900 font-dmsans text-sm leading-[22px] tracking-[-1%]">Verification Status</p>}
              name="isVerified"
              rules={[
                { required: true, message: "Please enter Mobile" },
                // { min: 6, message: "isVerified must be at least 6 characters" },
              ]}
            >
              <Input placeholder="isVerified" disabled />
            </Form.Item>
          </Col>

        {/* <Col>
            <Form.Item label={<p className="font-normal text-gray-900 font-dmsans text-sm leading-[22px] tracking-[-1%]">Verification Status</p>} name="isVerified" rules={[{ required: true, message: "Please select an option" }]}>
              <Select placeholder="isVerified" suffixIcon={<Image src={`${dropDownImage}`} preview={false} />}>
                {[
                  { label: "True", value: true },
                  { label: "False", value: false },
                ].map((option) => (
                  <Select.Option key={option.value} value={option.value}>
                    {option.label}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col> */}

          <Col>
            <Form.Item label={<p className="font-normal text-gray-900 font-dmsans text-sm leading-[22px] tracking-[-1%]">Active Status</p>} name="isActive" rules={[{ required: true, message: "Please select an option" }]}>
              {/* <Select placeholder="isActive"
              suffixIcon={<Image src={`${dropDownImage}`} preview={false} />}
              >
                {[
                  { label: "True", value: true },
                  { label: "False", value: false },
                ].map((option) => (
                  <Select.Option key={option.value} value={option.value}>
                    {option.label}
                  </Select.Option>
                ))}
              </Select> */}
              <Switch
              onChange={() => updateContentData()}
              />
            </Form.Item>
          </Col>
        </Row>

        <Row className="grid grid-cols-1  gap-4">
          <Col>
            <Form.Item name="image" label={<p className="font-normal text-gray-900 font-dmsans text-sm leading-[22px] tracking-[-1%]">Image</p>}>
              <div className="relative rounded-[11px] mt-5 flex justify-center items-center h-32 w-[127px] aspect-video overflow-hidden">
                {uploading ? (
                  <div className="w-[127px] h-[127px] border rounded-sm flex justify-center items-center">
                    <ImSpinner10 />
                  </div>
                ) : imageURL ? (
                  <Image src={imageURL} height={127} width={127} className="rounded-sm object-cover" preview={false} />
                ) : (
                  <div className="w-[127px] h-[127px] border rounded-sm"></div>
                )}

                {/* <input type="file" name="photo" id="upload-photo" onChange={handleFileUpload} />
                <label for="upload-photo" className="cursor-pointer">
                  <EditOutlined className="absolute text-xs bg-red-600 top-1 right-1 rounded-full text-white w-[22px] h-[22px] flex justify-center items-center  bottom-0 opacity-80" />
                </label> */}
                {/* <button >Replace</button> */}
              </div>
            </Form.Item>
          </Col>
        </Row>

        <Row className="flex justify-between">
          <Form.Item>
            <Button
              onClick={() => {
                // navigate("/");
                navigate("/get/user_details");
              }}
              className="RemoveButtonHover cancel-button"
              size="small"
            >
              Cancel
            </Button>
          </Form.Item>

          {/* <Form.Item>
            <Button className="NoButtonHover create-button" size="small" htmlType="submit" loading={isLoading}>
              {from === "edit" ? "Edit" : "Create"} Content
              Update
            </Button>
          </Form.Item> */}
        </Row>
      </Form>
    </div>
  );
}

export default EditUser;
